import React from 'react';
import styled from 'styled-components';
import { useRegistration } from '../../contexts/RegistrationContext';

const StepContainer = styled.div`
  background: white;
  padding: 1.5rem 2rem;
  border-bottom: 2px solid #000;
`;

const StepList = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
`;

const Step = styled.div<{ active: boolean; completed: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  color: ${props => props.active ? '#000' : props.completed ? '#000' : '#666'};
  font-size: 0.9rem;
`;

const StepNumber = styled.div<{ active: boolean; completed: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  background: ${props => props.active ? '#000' : props.completed ? '#000' : 'white'};
  color: ${props => props.active || props.completed ? 'white' : '#666'};
  font-weight: 600;
  border: 2px solid #000;
  box-shadow: ${props => props.active ? '0 4px 12px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.1)'};
`;

const StepTitle = styled.div`
  text-align: center;
  font-size: 0.8rem;
  font-weight: 500;
  color: #000;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background: #f0f0f0;
  border-radius: 2px;
  margin: 1rem 0 0 0;
  overflow: hidden;
`;

const ProgressFill = styled.div<{ progress: number }>`
  height: 100%;
  background: #000;
  border-radius: 2px;
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

const steps = [
  { number: 1, title: 'Business Activity' },
  { number: 2, title: 'Company Name' },
  { number: 3, title: 'Owners & Shares' },
  { number: 4, title: 'Charter' },
  { number: 5, title: 'Services' },
  { number: 6, title: 'Summary' },
];

const StepIndicator: React.FC = () => {
  const { currentStep } = useRegistration();
  
  // Calculate progress percentage
  const progress = ((currentStep - 1) / (steps.length - 1)) * 100;

  return (
    <StepContainer>
      <StepList>
        {steps.map((step) => (
          <Step
            key={step.number}
            active={currentStep === step.number}
            completed={currentStep > step.number}
          >
            <StepNumber
              active={currentStep === step.number}
              completed={currentStep > step.number}
            >
              {currentStep > step.number ? '✓' : step.number}
            </StepNumber>
            <StepTitle>{step.title}</StepTitle>
          </Step>
        ))}
      </StepList>
      <ProgressBar>
        <ProgressFill progress={progress} />
      </ProgressBar>
    </StepContainer>
  );
};

export default StepIndicator;